var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.7,1143.3c13,13,30.1,19.5,47.3,19.5s34.2-6.5,47.3-19.5c26.1-26.1,26.1-68.3,0-94.5l-382.1-382h905.1 c36.9,0,66.8-29.9,66.8-66.8s-29.9-66.8-66.8-66.8H228.1l382-382c26.1-26.1,26.1-68.3,0-94.5c-26.1-26.1-68.5-26.1-94.5,0l-496,496 c-26.1,26.1-26.1,68.3,0,94.5L515.7,1143.3z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.2ab44d12bf37a76f883942ec74f4a6eb.svg";
export { ForwardRef as ReactComponent };